import { AxiosError } from 'axios'
import { ApiError } from 'EstraSponsor'
import { useMutation, UseMutationResult } from 'react-query'

export const useLogout = (
  logout: () => Promise<void>
): UseMutationResult<void, AxiosError<ApiError>, void> => {
  return useMutation(logout)
}
